import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { FileTransfer, FileTransferObject, FileUploadOptions } from '@ionic-native/file-transfer/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { ActionSheetController, IonItemSliding, ModalController } from '@ionic/angular';
import { CargardocPage } from 'src/app/pages/cargardoc/cargardoc.page';
import { CarpetaPage } from 'src/app/pages/carpeta/carpeta.page';
import { ApiserviceService } from 'src/app/services/apiservice.service';
//import { FilePicker, FilePickerOptions } from '@capacitor-community/file-picker';
//import { FilePicker, FilePickerOptions } from '@capacitor-community/file-picker/';
//import { FilePicker,PickFilesOptions } from '@capawesome/capacitor-file-picker';
import axios from 'axios';
import { File } from '@ionic-native/file/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Chooser } from '@ionic-native/chooser/ngx';
import { VerdocumentosPage } from 'src/app/pages/verdocumentos/verdocumentos.page';
import { VerdocumentosPageModule } from 'src/app/pages/verdocumentos/verdocumentos.module';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss'],
})
export class TreeComponent implements OnInit {

  @Input() folder: any;
  @Input() contador: any;
  @Input() filtro: any;

  @Input() padre: VerdocumentosPage;
  

 fileUrl: SafeResourceUrl;
 auxvista=false;

  img=true; 
  imagedoc=''
  
  aux="false"
  mymargen=""
  constructor(private sanitizer: DomSanitizer,    
    public apiservice: ApiserviceService,
    private actionSheetCtrl: ActionSheetController,
    private modalCtrl:  ModalController,
    private fileChooser: FileChooser,
    private fileTransfer: FileTransfer,
    private file :File,
    private filePath: FilePath,
    private androidPermissions: AndroidPermissions,
    private chooser:Chooser
   
    ) {

    
//"{'padding-left':'10px'}"



   }

  ngOnInit() {

    this.inicializar()

 /*   var margen=String(10*Number(this.contador))+'px';
    console.log(this.folder)
    console.log(this.contador)
    console.log(margen);
   this.mymargen=margen

   var result=this.buscarecursiva(this.folder.subfolders,false);*/

 //  console.log(this.folder);

  //var union= this.folder.subfolders.map(x=>{ return x.name}).join(',').toUpperCase();
  //console.log(union);
 //this.aux= union.includes(this.filtro)
 //console.log(this.aux);

  }

  async inicializar(){

    var margen=String(10*Number(this.contador))+'px';
    console.log(this.folder)
    console.log(this.contador)
    console.log(margen);
   this.mymargen=margen;

   console.log(this.folder);
   console.log(this.folder.subfolders);

   var result=this.buscarecursiva(this.folder.subfolders,false);


  }

  async  uploadFiles(result) {

    console.log('incio2 subiendo archivos...')

    const formData = new FormData();
    
    // Agrega cada archivo al formData
    result.files.forEach((file, index) => {
     // formData.append(`file${index}`, file.data, file.name);
   
      formData.append('archivo', file['blob']);
      formData.append('nombre', file.name);
      console.log('incio3 subiendo archivos...'+file.name)
    });

    
  
    try {
      // Realiza la solicitud HTTP para enviar los archivos al servidor
      const response = await axios.post(encodeURI("https://negociosinmobiliariosryr.com/mantenimiento/docionic/upload2.php"), formData, {
        headers: {
         'Content-Type': 'multipart/form-data',
        
        },
      });
  
      // Manejar la respuesta del servidor según sea necesario
      console.log(response.data);
    } catch (error) {
      console.error('Error al enviar archivos al servidor', error);
    }
  }

 /* 
async  pickFiles() {
  const result = await FilePicker.pickFiles({
    multiple: true, // Si deseas seleccionar múltiples archivos
   // types: ['image/*', 'application/pdf', 'text/plain'], // Tipos de archivos permitidos
  });

  // `result.files` contiene la información sobre los archivos seleccionados

  console.log('inicio subiendo archivos...')
  console.log(result.files);
  this.uploadFiles(result);
}*/

  /*
  async pickFiles() {
    const options: PickFilesOptions  = {
      multiple: true,
      onPick: async (result) => {
        // Result contiene la información de los archivos seleccionados
        const files = result.files.map((file) => file.uri);
        
        // Enviar archivos al servidor
        this.uploadFiles(files);
      },
    };

    await FilePicker.pickFiles(options);
  }*/




  verificar(){

var uri=this.filtro;

    
this.filePath.resolveNativePath(uri)
.then(filePath => {

  console.log("mostarndo file path")
  console.log(filePath); // The file path corresponding to the content URI
  // Now you can work with the file path
  
  

    this.file.resolveLocalFilesystemUrl(filePath)
    .then(fileEntry => {
     
      console.log('entrada...')
      console.log(JSON.stringify(fileEntry))

      console.log(fileEntry.filesystem.encodeURIPath)
  console.log(fileEntry.toURL())
      }).catch(err => {console.log('erro interno')
    
      console.log(JSON.stringify(err))});

      

    
  })
  .catch(err => {
    
    console.log('erro 1')
    
    console.log(JSON.stringify(err))});




  }



  async openFileChooser() {

   

    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE)
    .then(
      result => console.log('Has permission?',result.hasPermission),
      err => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE)
    );


     const permission = await this.androidPermissions.requestPermission(
      this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE
    );


    this.chooser.getFile().then(filePath => {

      console.log("filePath.dataURI")
      console.log(filePath.dataURI);
      console.log('filePath.data')
      console.log(filePath.data)
      console.log('filePath.mediaType')
      console.log(filePath.mediaType)
      console.log('filePath.name')
      console.log(filePath.name)
      console.log('filePath.uri')
      console.log(filePath.uri)

      const fileTransfer: FileTransferObject = this.fileTransfer.create();
      let options = {
        fileKey: 'archivo',
        fileName: filePath.name,
        chunkedMode: false,
        mimeType: 'multipart/form-data',
        params : {'nombre':filePath,'extension':filePath.mediaType},
        headers: {}
      };
      
        fileTransfer.upload(filePath.uri, encodeURI("https://oilandgas.com.co/appdocumentos/upload.php"), options)
        .then((data) => {
          // Manejar la respuesta del servidor
          console.log(data.response);
        }, (err) => {
          // Manejar errores
          console.log(err);
        });
        
    

    });



  
/*

    if (permission.hasPermission) {

    this.fileChooser.open()
      .then(uri => {

        console.log('valor de uri');
        console.log(uri); // La URI del archivo seleccionado
        // También puedes obtener el nombre y la extensión del archivo

       console.log('seguridad')
       console.log(this.sanitizer.bypassSecurityTrustUrl(uri));

      

    /*
        this.FilePath.resolveNativePath(uri, absolutePath => {
          this.file.resolveLocalFileSystemURL(absolutePath, fileEntry => {
            fileEntry.file(file => {
              const { name, size } = file;
              console.log(`The name of this file is ${name} and its size is ${size}`);
            });
          }, error => console.error(error));
        }, error => console.error(error));
*/

/*
this.filePath.resolveNativePath(uri)
.then(filePath => {

  console.log("mostarndo file path")
  console.log(filePath); // The file path corresponding to the content URI
  // Now you can work with the file path
  
  

    this.file.resolveLocalFilesystemUrl(filePath)
    .then(fileEntry => {
     
      console.log('entrada...')
      console.log(JSON.stringify(fileEntry))

      console.log(fileEntry.filesystem.encodeURIPath)
  console.log(fileEntry.toURL())
      }).catch(err => {console.log('erro interno')
    
      console.log(JSON.stringify(err))});

      

    
  })
  .catch(err => {
    
    console.log('erro 1')
    
    console.log(JSON.stringify(err))});

})



      

/*
        console.log('filepath-->')
        this.filePath.resolveNativePath(uri)
        .then(filePath => {
           console.log(filePath)
         // now do what you want with the filePath
        })*/



   
/*
       

        

        


   /*
      .catch(error => console.log('Error al abrir el selector de archivos:', error));
 
      }else{

        console.log("notiene permisos..")
      }*/
 
    }


  buscarecursiva(folder,isrec){

  var result=false;
try {
  

  for(var i=0;i<folder.length;i++){

  if(folder[i]['tipo']==0 && !isrec){result=false;}

    if(folder[i].subfolders.length>0){
      var aux=this.buscarecursiva(folder[i].subfolders,true)
      folder[i]['visible']=aux;
      if(!result){
        result=aux;
      }
     // result=false;
     // return result;

    }else{

      var aux= folder[i].name.toUpperCase().includes(this.filtro);
      if(!result){
        result=aux;
      }
     
      if(folder[i].tipo==0){ folder[i]['visible']=result;}
      else{folder[i]['visible']=aux;}
    }
     
  }

} catch (error) {

  console.log('error...');
  console.log(JSON.stringify(error))
  
}

  return result;
    //var union= folder.map(x=>{ return x.name}).join(',').toUpperCase();

 

  //console.log(union);


  }


  concar(folder){

  var res= folder.filter(x=>{ return x.visible});

  if(res.length==folder.length)
  return folder.length
  else
  return (res.length+"/"+folder.length);


  }

  closeItem(slidingItem: IonItemSliding) {
    slidingItem.close();
  }

  async presentActionSheet(folder,titulo,slidingItem: IonItemSliding) {
    const actionSheet = await this.actionSheetCtrl.create({
      mode:'md',
      cssClass:'my-custom-class',
      header: titulo,      
      buttons: [
        {
          text: 'Si',   
          handler:()=>{
           // this.apiservice.mensaje('Si','success')
            this.eliminar(folder);
            slidingItem.close();
          },
        },
        {
          text: 'No',
          handler:()=>{
          //  this.apiservice.mensaje('No','danger')
            slidingItem.close();
          },          
        },
        
      ],
    });

    await actionSheet.present();

    //const result = await actionSheet.onDidDismiss();
    //this.result = JSON.stringify(result, null, 2);
  }

  async eliminar(folder){

    console.log(folder);

  var result = await this.apiservice.postapi2eli(JSON.stringify({'elim':folder.url,'tipo':folder.tipo,'name':folder.name})); //


   if(result.sali){
    

    var result = await this.apiservice.postapi2doc(JSON.stringify({'raiz':this.apiservice.carpetafolderes})); //
   
    if(result.length>0){

    console.log(result[0]);
    console.log(this.apiservice.folderes);  

    this.apiservice.recur=false;
    this.apiservice.startloading();
    setTimeout(() => {

      this.apiservice.folderes=result[0];
      this.apiservice.recur=true;

    //  console.log(this.mytree.filtro)    
      this.apiservice.closedloading();
      //this.mytree.inicializar();
      
    },2500);

     }



   }
else{

  this.apiservice.mensaje('Error eliminando...','danger');
}


   //this.apiservice.folderes=[];
   

  }

  
  confirmar(folder,slidingItem){
    //this.apiservice.mensaje('Eliminando '+folder.name,'danger');

    var  texto=""
    if(folder.tipo==0){
      texto="la carpeta ";
    }else{
      texto="el archivo "    
    }

    this.presentActionSheet(folder,'Quiere eliminar '+texto+ folder.name,slidingItem);
  }

  

  async modalcardoc(folder,slidingItem){

    var idetificador=''
    var carpeta='';
    var raiz='';


    const modal= await this.modalCtrl.create({
  
      component: CargardocPage,
      showBackdrop:true,
      cssClass:'full',
      componentProps: {
        'folder':folder,
       
    
      }

    });
     await modal.present();
  
     const {data} =  await modal.onDidDismiss();

     slidingItem.close();
  
     console.log("data regreso....");
     console.log(JSON.stringify(data));

     console.log(JSON.stringify(this.folder.subfolders));
     for(var f=0;f<data.length;f++)
     this.folder.subfolders.push(data[f]);

     console.log(JSON.stringify(this.folder.subfolders));
     //this.inicializar()
    // console.log(String(data["id"]).length);

     ///////////////////////////////////////////////////////////////////

     
     
  
    }


  async nuevacarpeta(folder,slidingItem){
    
    
    const modal= await this.modalCtrl.create({
  
      component: CarpetaPage,
      showBackdrop:true,
      cssClass:'full',
      componentProps: {
        'folder':folder,   
      }

    });
     await modal.present();
  
     const {data} =  await modal.onDidDismiss();

     slidingItem.close();
  
     console.log("data regreso....");
     console.log(data);

     if(data.length>0)
     this.folder.subfolders.push(data[0])
  }

  cargdoc(folder){

    folder.estado=!folder.estado
    //console.log(folder);

    if(folder.tipo==1){
    //carga el archivo...
 
    var secdoc=folder.url.substring(2,folder.url.length);


    this.apiservice.rutadoc=secdoc;   //folder.url
    this.apiservice.setfileurl(secdoc);    //folder.url

   // console.log(this.apiservice.fileUrl )
    this.apiservice.listdoc=false;

  
if(String(secdoc).toUpperCase().includes(".PNG") || String(secdoc).toUpperCase().includes(".JPG") ||  String(secdoc).toUpperCase().includes(".JPEG") ||  String(secdoc).toUpperCase().includes(".JPG") ||  String(secdoc).toUpperCase().includes(".WEBP") )
{
  this.apiservice.imgestado=true;
  this.apiservice.imagedoc='https://oilandgas.com.co'+secdoc;
}
else{

  
 this.apiservice.imagedoc="";
 this.apiservice.imgestado=false;

 //var url = 'https://docs.google.com/gview?url=https://negociosinmobiliariosryr.com/mantenimiento/docionic/soportesapls/apl'+d.info.identificador+'/'+d.info.nombre+'&embedded=true';
 // this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
}


    }




//this.auxvista=true;

  }

}
